import callApi from '../common/api/apiRequest'

export default async (id: string): Promise<void> => {
  return callApi<void>('delete', `webhooks`, { id })
}
